import { combineReducers } from 'redux';
import brands from './brands';
import providers from './cellular-providers';
import countries from './countries';
import currencies from './currencies';
import insuranceAgents from './insurance-agents';
import insuranceCompanies from './insurance-companies';
import locationClasses from './location-classes';
import paymentMethods from './payment-methods';
import sensorBrands from './sensor-brands';
import sensorMeasures from './sensor-measures';
import sensorModels from './sensor-models';
import timeZones from './time-zones';
import vehicleMakers from './vehicle-makers';
import vehicleModels from './vehicle-models';

const staticCatalogs = combineReducers({
  currencies,
  timeZones,
  countries,
  providers,
  vehicleMakers,
  vehicleModels,
  insuranceCompanies,
  insuranceAgents,
  sensorBrands,
  sensorModels,
  sensorMeasures,
  paymentMethods,
  locationClasses,
  brands
});

export default staticCatalogs;

//Own state
export const getOwnState = (state) => state.staticCatalogs;
